import React from 'react';
import { MarketLink } from '@market/react-bindings';
import classNames from 'classnames';
import { IconImagePlaceholder } from '../icons/IconImagePlaceholder';
import { ImageUploadProps } from '../image-upload/ImageUpload';

export const MarketImageUpload: React.FC<React.PropsWithChildren<ImageUploadProps>> = ({
  hasError,
  errorMessage,
  className,
  uploaderHeightClass = 'tw-h-56',
  title = 'Click to upload image',
  onClick,
  disabled,
}) => {
  return (
    <div className={classNames(['tw-border tw-border-dashed tw-rounded-md', hasError ? 'tw-border-red-400' : ''])}>
      <MarketLink disabled={disabled || undefined} className={classNames(['tw-flex tw-justify-center', className, uploaderHeightClass])} onClick={onClick}>
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-space-y-2">
          <IconImagePlaceholder />
          <span>{title}</span>
        </div>
      </MarketLink>
      {hasError && errorMessage && (
        <div className="tw-text-center tw-py-1 tw-bg-red-100 tw-text-red-400 tw-rounded-b-inherit">• {(errorMessage as string).replace('url', 'image')}</div>
      )}
    </div>
  );
};
